const formatDateHead = (num) => {
  const d = new Date(num);
  const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
  const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(d);
  const newDate = `${da} ${mo}`;
  return newDate;
};

const setArrOfdates = (max) => {
  const today = new Date();
  const week = [];
  for (let i = 1; i <= max; i++) {
    let day = new Date();
    week.push(day.setDate(today.getDate() - i));
  }
  return week;
};

export const newDates = setArrOfdates(7).map((item) => formatDateHead(item));

export const aheadDates = setArrOfdates(2).map((item) => formatDateHead(item));

export const dataToAhead = (obj) => {
  const asArray = Object.entries(obj);
  const filtered = asArray.filter(
    ([key]) =>
      (key === "col1") |
      (key === "col2") |
      (key === "col3") |
      (key === "col9") |
      (key === "col10")
  );
  const justAhead = Object.fromEntries(filtered);
  return justAhead;
};
